import { Injectable } from '@angular/core';
import { CanLoad, Route, Router, UrlSegment, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanLoad {
  private loginPath = 'login';
  private monitorPath = 'monitor'; 

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
  ) {}

  canLoad(
    route: Route,
    segments: UrlSegment[]
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    let isAuthenticated = false;

    const localJwt = (this.authenticationService.getTokenFromLocalStorage());
    if (localJwt != undefined) {
      const jwt = JSON.parse(localJwt);
      const token = jwt.token;
      isAuthenticated = (token != undefined && !this.authenticationService.isTokenExpired(token))
    }
    
    if (!isAuthenticated) {
      this.authenticationService.logout();

      if(route.path.indexOf(this.monitorPath) == 0){
        this.router.navigate([`/${this.monitorPath}/${this.loginPath}`]);
      } else {
        this.router.navigate([`/${this.loginPath}`]);
      }
      return false;
    } else {
      return true;
    }
  }
}
